var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2913 39.8756V45.459H27.708V39.8756H33.2913ZM33.2913 15.5423V33.2923H27.708V15.5423H33.2913ZM0.333008 30.5006C0.333008 13.8484 13.8177 0.333984 30.4693 0.333984C47.1518 0.333984 60.6663 13.8489 60.6663 30.5006C60.6663 47.1524 47.1518 60.6673 30.4693 60.6673C13.8177 60.6673 0.333008 47.1529 0.333008 30.5006ZM5.91634 30.5006C5.91634 44.0829 16.9174 55.084 30.4997 55.084C44.0819 55.084 55.083 44.0829 55.083 30.5006C55.083 16.9184 44.0819 5.91732 30.4997 5.91732C16.9174 5.91732 5.91634 16.9184 5.91634 30.5006Z",
    fill: "url(#paint0_linear_1473_1534)",
    stroke: "black",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1473_1534",
    x1: 5,
    y1: 20.5,
    x2: 57,
    y2: 34.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.fdd8aa971304d7f66609028c0cdde576.svg";
export { ForwardRef as ReactComponent };